export default __webpack_public_path__ + "static/media/2021-Estados-Financieros-30.06.2021.ab549de8.webp";